export default __webpack_public_path__ + "static/media/Sorting_09.c6988ca0.png";